/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Delete_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Delete member" |
*
* @param {Member_Delete_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_delete_modal_title = /** @type {((inputs?: Member_Delete_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Delete_Modal_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina membro")
	return /** @type {LocalizedString} */ ("Delete member")
});